import { Link } from 'react-router-dom';
import { Card, Icon, Image } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { Profile } from '../../app/models/Profile';
import FollowButton from './FollowButton';
import FriendRequestButton from '../friends/FriendRequestButton';
import { useTranslation } from 'react-i18next';

interface Props {
  profile: Profile;
}

export default observer(function ProfileCard({ profile }: Props) {
  const { t } = useTranslation();

  // Prevent click propagation to card link
  const handleButtonAreaClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <Card 
      as={Link} 
      to={`/profiles/${profile.userID}`}
      style={{ 
        maxWidth: '100%',
        wordWrap: 'break-word',
        overflow: 'hidden'
      }}
    >
      <Image src={profile.image || '/assets/user.png'} />
      <Card.Content>
        <Card.Header 
          style={{ 
            fontSize: 'clamp(0.9rem, 2.5vw, 1.28rem)',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            hyphens: 'auto',
            lineHeight: '1.2'
          }}
        >
          {profile.fullName}
        </Card.Header>
        <Card.Description></Card.Description>
      </Card.Content>
      <Card.Content 
        extra
        style={{ 
          fontSize: 'clamp(0.7rem, 2vw, 0.9rem)',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          whiteSpace: 'nowrap'
        }}
      >
        <Icon name='user' />
        <span style={{ 
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>
          {profile.followersCount} {t('profileCard.followers')}
        </span>
      </Card.Content>
      <div 
        onClick={handleButtonAreaClick}
        style={{ marginBottom: '0.5em', position: 'relative', zIndex: 1 }}
      >
        <FollowButton profile={profile}/>
      </div>
      <div 
        onClick={handleButtonAreaClick}
        style={{ position: 'relative', zIndex: 1 }}
      >
        <FriendRequestButton userId={profile.userID} />
      </div>
    </Card>
  );
});